import { SignUp, useAuth } from '@clerk/clerk-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';
import React from 'react';
import { z } from 'zod';

const signUpSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/sign-up')({
  validateSearch: signUpSearchSchema,
  component: SignUpComponent,
});

function SignUpComponent() {
  const navigate = useNavigate({ from: Route.fullPath });
  const { isSignedIn, isLoaded } = useAuth();
  const { redirect } = Route.useSearch(); // Now correctly typed

  React.useEffect(() => {
    if (isLoaded && isSignedIn) {
      // If user is already signed in, redirect them away from sign-up page
      const redirectTo = redirect || '/'; // Default to home or use redirect param
      navigate({ to: redirectTo, replace: true });
    }
  }, [isSignedIn, isLoaded, navigate, redirect]);

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
      </div>
    );
  }

  if (!isSignedIn) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
        <SignUp
          routing="path" // Use path-based routing
          path="/sign-up" // Current path for sign-up
          signInUrl="/login" // URL for the sign-in page
          forceRedirectUrl={redirect || '/'} // Redirect after successful sign-up, or to a specific welcome page
          // afterSignUpUrl is deprecated in favor of forceRedirectUrl or navigation via callbacks
        />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen">
      <p>Redirecting...</p>
      <Loader2 className="h-8 w-8 animate-spin text-primary ml-2" />
    </div>
  );
}
